import React, { PropsWithChildren } from "react";

const CardContainer : React.FC<PropsWithChildren> = ({children}) =>
    <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-3 md:gap-6 lg:gap-6 items-start md:max-w-none">
        {children}
    </div>

export default CardContainer;